import { render, staticRenderFns } from "./opt-goals.vue?vue&type=template&id=7b1c7884&scoped=true"
import script from "./opt-goals.vue?vue&type=script&lang=js"
export * from "./opt-goals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1c7884",
  null
  
)

export default component.exports